import { Component, Input, Output, EventEmitter, ViewChild, TemplateRef, AfterViewInit } from '@angular/core';
import { DataTableColumn } from '../../../shared/ui/data-table/data-table.component';

@Component({
  selector: 'app-sales-challenge-list',
  templateUrl: './sales-challenge-list.component.html',
  styleUrls: ['./sales-challenge-list.component.scss']
})
export class SalesChallengeListComponent implements AfterViewInit {
  @Input() dataSource: any = { content: [], totalElements: 0 };
  @Input() salesChallengePage: number = 1;
  @Input() pageSize: number = 10;
  @Input() salesChallengeLoading: boolean = false;

  @Output() refresh = new EventEmitter<void>();
  @Output() toggleLayout = new EventEmitter<void>();
  @Output() openBudgetCap = new EventEmitter<void>();
  @Output() pageChange = new EventEmitter<number>();
  @Output() submitForApproval = new EventEmitter<any>();
  @Output() finalizeChallenge = new EventEmitter<any>();
  @Output() filePopup = new EventEmitter<{ row: any, type: string }>();
  @Output() approvalTracker = new EventEmitter<any>();
  @Output() editChallenge = new EventEmitter<any>();
  @Output() copyChallenge = new EventEmitter<any>();

  @ViewChild('scBudgetCapTpl') scBudgetCapTpl!: TemplateRef<any>;
  @ViewChild('scUpdatedOnTpl') scUpdatedOnTpl!: TemplateRef<any>;
  @ViewChild('scStatusTpl') scStatusTpl!: TemplateRef<any>;
  @ViewChild('scActionTpl') scActionTpl!: TemplateRef<any>;
  @ViewChild('scEditTpl') scEditTpl!: TemplateRef<any>;

  salesChallengeColumns: DataTableColumn[] = [];

  ngAfterViewInit() {
    setTimeout(() => { this.buildColumns(); });
  }

  buildColumns() {
    this.salesChallengeColumns = [
      { field: 'challengename', header: 'Challenge Name', align: 'left', isBold: true },
      { field: 'percentage', header: 'Budget Cap', align: 'left', cellTemplate: this.scBudgetCapTpl },
      { field: 'createdBy', header: 'Created By', align: 'left' },
      { field: 'fiscalPeriod', header: 'Fiscal Period', align: 'left' },
      { field: 'modifiedOn', header: 'Updated On', align: 'left', cellTemplate: this.scUpdatedOnTpl },
      { field: 'status', header: 'Status', align: 'left', cellTemplate: this.scStatusTpl },
      { field: 'action', header: 'Action', align: 'left', cellTemplate: this.scActionTpl },
      { field: 'edit', header: '', align: 'center', cellTemplate: this.scEditTpl },
    ];
  }

  formatStatus(status: string): string {
    if (!status) { return ''; }
    return status.split('_').join(' ');
  }
}
